(() => {
  if (window.CollabLandingInitialized) return;
  window.CollabLandingInitialized = true;

  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  let activeModal = null;
  let lastTrigger = null;
  let observer = null;

  const closeModal = (modal = activeModal) => {
    if (!modal) return;

    modal.hidden = true;
    document.documentElement.classList.remove('collab-modal-open');
    activeModal = null;

    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  };

  const openModal = (modal, trigger) => {
    if (!modal) return;

    if (activeModal && activeModal !== modal) closeModal(activeModal);

    lastTrigger = trigger;
    activeModal = modal;
    modal.hidden = false;
    document.documentElement.classList.add('collab-modal-open');

    requestAnimationFrame(() => {
      modal.querySelector('.collab-modal__close')?.focus();
    });
  };

  const getObserver = () => {
    if (observer || !('IntersectionObserver' in window)) return observer;

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -4% 0px' }
    );

    return observer;
  };

  const initReveal = (root = document) => {
    const elements = root.matches?.('.collab-float-in')
      ? [root]
      : [...root.querySelectorAll?.('.collab-float-in') || []];

    if (!elements.length) return;

    document.documentElement.classList.add('collab-reveal-ready');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('is-visible'));
      return;
    }

    const revealObserver = getObserver();
    elements.forEach((element) => {
      if (element.dataset.collabRevealObserved === 'true') return;
      element.dataset.collabRevealObserved = 'true';
      revealObserver.observe(element);
    });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-collab-modal-open]');
    if (trigger) {
      const modal = document.getElementById(trigger.dataset.collabModalOpen);
      openModal(modal, trigger);
      return;
    }

    const close = event.target.closest('[data-collab-modal-close]');
    if (close) closeModal(close.closest('[data-collab-modal]'));
  });

  document.addEventListener('keydown', (event) => {
    if (!activeModal) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = [...activeModal.querySelectorAll(focusableSelector)].filter(
      (element) => !element.hasAttribute('hidden') && element.offsetParent !== null
    );

    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  const init = (root = document) => initReveal(root);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    if (activeModal && event.target.contains(activeModal)) closeModal(activeModal);
  });

  /*
   * =========================================================
   * BOOST MOBILE FILTER
   * =========================================================
   */

  const MOBILE_BREAKPOINT = 1199;
  const FILTER_OPEN_CLASS = 'has-filter-mobile';
  const REFINE_BUTTON_SELECTOR =
    '.boost-sd__filter-tree-toggle-button';

  const html = document.documentElement;

  let wasFilterOpen =
    html.classList.contains(FILTER_OPEN_CLASS);

  const scrollToRefineBy = () => {
    const refineButton =
      document.querySelector(REFINE_BUTTON_SELECTOR);

    if (!refineButton) {
      return;
    }

    refineButton.scrollIntoView({
      behavior: 'auto',
      block: 'start'
    });
  };

  const restoreFilterScroll = () => {
    /*
     * Boost/CSS cần thời gian:
     * 1. đóng fixed filter
     * 2. show lại KIZZU
     * 3. restore layout
     */
    setTimeout(() => {
      scrollToRefineBy();

      /*
       * Boost có thể còn update DOM sau lần scroll đầu.
       * Scroll lần 2 để giữ đúng vị trí cuối cùng.
       */
      setTimeout(() => {
        scrollToRefineBy();
      }, 300);
    }, 100);
  };

  const filterObserver = new MutationObserver(() => {
    const isFilterOpen =
      html.classList.contains(FILTER_OPEN_CLASS);

    // OPEN -> CLOSED
    if (
      window.innerWidth <= MOBILE_BREAKPOINT &&
      wasFilterOpen &&
      !isFilterOpen
    ) {

      restoreFilterScroll();
    }

    wasFilterOpen = isFilterOpen;
  });

  filterObserver.observe(html, {
    attributes: true,
    attributeFilter: ['class']
  });

})();
